<template>
  <div :class="['circle', color]" :style="{ width: size + 'px', height: size + 'px' }">
    <span class="number">{{ number }}</span>
  </div>
</template>

<script>
export default {
  props: {
    number: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: true,
      validator: value => {
        return ['red', 'yellow', 'green'].includes(value)
      }
    },
    size: {
      type: Number,
      default: 100
    }
  }
}
</script>

<style>
.circle {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 16px;
  color: #fff;
}

.red {
  background-color: #ff6666;
}

.yellow {
  background-color: #ffcc33;
}

.green {
  background-color: #33cca8;
}

.number {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/schema/CircleNumber.vue